// src/services/trips.js
import {
  addDoc,
  collection,
  serverTimestamp,
  query,
  where,
  getDocs,
  limit,
} from "firebase/firestore";
import { db } from "../firebase";

/** Check if a slug already exists */
export async function isSlugAvailable(slug) {
  const q = query(
    collection(db, "trips"),
    where("slug", "==", slug),
    limit(1)
  );
  const snap = await getDocs(q);
  return snap.empty;
}

/**
 * addTrip(tripData, ownerUid)
 * - tripData MUST include slug
 * - ownerUid = currentUser.uid
 *
 * Returns: { id, slug }
 */
export async function addTrip(tripData = {}, ownerUid) {
  if (!ownerUid) {
    throw new Error("addTrip: ownerUid is required.");
  }

  if (!tripData.slug) {
    throw new Error("addTrip: slug is required.");
  }

  // Ensure slug is unique
  const available = await isSlugAvailable(tripData.slug);
  if (!available) {
    throw new Error("Slug already exists");
  }

  const doc = {
    title: (tripData.title || "").trim(),
    slug: tripData.slug, // ✅ IMPORTANT
    startLocation: tripData.startLocation || null,
    destination: tripData.destination || null,
    startDate: tripData.startDate || null,
    endDate: tripData.endDate || null,
    notes: (tripData.notes || "").trim(),
    visibility: tripData.visibility || "private",
    owner_id: ownerUid,
    allowedUsers: [ownerUid],
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };

  const ref = await addDoc(collection(db, "trips"), doc);

  return { id: ref.id, slug: tripData.slug };
}
